const View = () => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 628 641"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <clipPath id="clipPath15">
          <path
            d="m247.79 12.913c0.79751-5.9673 5.2073-10.826 11.089-12.217 5.8814-1.3941 12.015 0.96873 15.427 5.9378l122.66 178.71 213.8-39.103c5.9456-1.0868 11.95 1.5883 15.096 6.727 3.1481 5.1387 2.7876 11.679-0.90368 16.444l-132.78 171.39 103.41 190.4c2.8765 5.2946 2.1753 11.806-1.758 16.375-3.9357 4.569-10.294 6.249-15.985 4.225l-204.72-72.787-149.89 156.77c-4.1678 4.3598-10.605 5.7094-16.185 3.3942-5.5802-2.3154-9.148-7.8162-8.9752-13.833l6.2567-216.37-196.05-93.507c-5.4518-2.5988-8.7295-8.276-8.2426-14.278 0.48691-5.9992 4.6379-11.079 10.438-12.773l208.59-60.939z"
            fill="#df2238"
            style={{ display: 'none', fillRule: 'evenodd', fill: '#000' }}
          />
          <path
            d="m-5-5h638v651h-638zm252.79 17.913-28.723 214.57-208.59 60.939c-5.8004 1.694-9.9514 6.7737-10.438 12.773-0.48691 6.0017 2.7908 11.679 8.2426 14.278l196.05 93.507-6.2567 216.37c-0.17284 6.0169 3.395 11.518 8.9752 13.833 5.5802 2.3151 12.017 0.96553 16.185-3.3942l149.89-156.77 204.72 72.787c5.6913 2.024 12.049 0.34397 15.985-4.225 3.9333-4.569 4.6345-11.081 1.758-16.375l-103.41-190.4 132.78-171.39c3.6913-4.765 4.0518-11.305 0.90368-16.444-3.1456-5.1387-9.1505-7.8138-15.096-6.727l-213.8 39.103-122.66-178.71c-3.4123-4.969-9.5455-7.3318-15.427-5.9378-5.8814 1.3916-10.291 6.25-11.089 12.217z"
            style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
          />
        </clipPath>
      </defs>
      <title>Red Star</title>
      <path
        d="M-1 -1H629V642H-1Z"
        clipPath="url(#clipPath15)"
        style={{ fill: '#fff', strokeWidth: 10.533 }}
      />
      <path
        d="m204.91 231.62 14.162-4.1367 22.723-169.75c-1.7044-0.29838-3.4843-0.25951-5.2383 0.15625-5.2206 1.2353-9.1339 5.5489-9.8418 10.846z"
        style={{ fillRule: 'evenodd', fill: '#df2238', strokeWidth: 0.88764 }}
      />
      <path
        d="m198.08 625.38c2.8e-4 -0.0102-2.9e-4 -0.021 0-0.0312l6.2578-216.37-193.79-92.428c-2.1247 2.119-3.493 4.9558-3.7461 8.0742-0.4322 5.3274 2.4772 10.367 7.3164 12.674l174.02 83.002-5.5527 192.06c-0.15342 5.3409 3.0136 10.224 7.9668 12.279 2.4352 1.0103 5.0542 1.2334 7.5273 0.74024z"
        style={{ fillRule: 'evenodd', fill: '#df2238', strokeWidth: 0.88764 }}
      />
      <path
        d="m536.79 537.2-163.66-58.189-11.385 11.908 157.94 56.154c5.0518 1.7966 10.696 0.3037 14.189-3.752 1.5374-1.7859 2.5174-3.9059 2.916-6.1211z"
        style={{ fillRule: 'evenodd', fill: '#df2238', strokeWidth: 0.88764 }}
      />
    </svg>
  );
};

export default View;
